import { isNullOrWhitespace, setFirstLetterToLowerCase } from "../../../common/stringOperations.ts";
import { InputFieldTypeEnum } from "../../inputFields/InputFields.types.ts";
import { DotLegalDatePicker } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import { useTranslation } from "../../../localization/useTranslation.ts";
import { useCustomField } from "./customField.hooks.ts";

export interface CustomDateFieldProps {
    /** Lets a caller that owns the vertical rhythm itself turn the field's own margin off. */
    noMargin?: boolean;
    /** Puts the label above the input with the help icon beside it, for a form laid out that way. */
    useFixedLabel?: boolean;
    isLoading: boolean;
    entityId: string;
    entityApiPath: string;
    customInputFieldId: string;
    fieldName: string;
    fieldDescription: string | undefined;
    value: Date | null;
    onChange: (changeFunc: (entity: any) => void) => void;
    readOnly?: boolean;
    isDisabled: boolean;
    errorText?: string;
    isPreview: boolean;
}

function CustomDateField(props: CustomDateFieldProps) {
    const { translateString, getDateTimePickerLanguage } = useTranslation();
    const { onFieldChange } = useCustomField(props.entityApiPath, props.entityId, props.customInputFieldId, props.onChange);

    return (
        <DotLegalDatePicker
            noMargin={props.noMargin}
            useFixedLabel={props.useFixedLabel}
            label={props.fieldName!}
            toolTipText={props.fieldDescription}
            value={isNullOrWhitespace(props.value?.toString()) ? null : props.value}
            onChange={props.readOnly ? () => {} : (date) => onFieldChange(date)}
            disabled={props.isDisabled}
            language={getDateTimePickerLanguage()}
            error={!isNullOrWhitespace(props.errorText)}
            helperMessage={
                props.errorText ||
                (props.isPreview ? translateString(setFirstLetterToLowerCase(InputFieldTypeEnum[InputFieldTypeEnum.DateField].toString())) : undefined)
            }
        />
    );
}

export default CustomDateField;
